export default "__VITE_ASSET__CbpWK0To__"